import React from 'react';
import { Link } from 'react-router-dom';
import { Button, Icon, EmptyList } from '../../components'

import noResults from '../../assets/images/search-noresults.svg';

const TemplatesNotFound = ({ search }) => {
  return (
    <EmptyList
      content={<>
        <img className="icon" src={noResults} width="80" height="80" alt="" />
        <h2 className="h1">
          Nenhum resultado encontrado
        </h2>
        <p>
          Não encontramos nenhum item que corresponda à sua pesquisa{search ? ` ${search}` : null}.
        </p>
        <p>
          Você pode procurar na sua lista de templates.
        </p>
        <Button as={Link} to={'/dashboard/templates'} variant="primary">
          <Icon id="icon-description" className="me-1" size="18" />
          VER TEMPLATES
        </Button>
      </>}
    />
  )
}

export default TemplatesNotFound;